export default __webpack_public_path__ + "static/media/icon-android.2ff88833.svg";